(() => {
  const storageKey = 'restromart:favourites';
  let memoryFavourites = [];

  const readFavourites = () => {
    if (typeof localStorage === 'undefined') return memoryFavourites;
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      memoryFavourites = Array.isArray(stored) ? stored : [];
      return memoryFavourites;
    } catch {
      return memoryFavourites;
    }
  };

  const writeFavourites = (items) => {
    memoryFavourites = items;
    if (typeof localStorage === 'undefined') return;
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      return;
    }
  };

  const toggleFavourite = (event) => {
    const button = event.currentTarget;
    const handle = button.dataset.productHandle;
    const saved = readFavourites();
    const existing = saved.findIndex((item) => item.handle === handle);
    if (existing >= 0) saved.splice(existing, 1);
    else saved.push({ handle, title: button.dataset.productTitle, url: button.dataset.productUrl });
    writeFavourites(saved);
    syncButtons();
    document.dispatchEvent(new CustomEvent('restromart:favourites-changed', { detail: { count: saved.length } }));
  };

  function syncButtons() {
    const saved = readFavourites();
    document.querySelectorAll('[data-rm-favorite]').forEach((button) => {
      const selected = saved.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(selected));
      if (!button.dataset.rmFavouriteReady) {
        button.dataset.rmFavouriteReady = 'true';
        button.addEventListener('click', toggleFavourite);
      }
    });
  }

  document.addEventListener('shopify:section:load', syncButtons);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncButtons);
  else syncButtons();
})();
